import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '@environment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DOCUMENT_VIEWER_MODAL_ID } from '@sb-tools/typescript/constants/nested-modal-ids';
import { DocumentViewerModalComponent } from '@sb-document-viewer/components/document-viewer-modal/document-viewer-modal.component';

@Injectable({
    providedIn: 'root',
})
export class FaqWidgetService implements OnDestroy {
    constructor(private bsModalService: BsModalService) {}

    init() {
        this.receiveMessage = this.receiveMessage.bind(this);
        window.addEventListener('message', this.receiveMessage);

        window['sbWidget'] = {
            community: 'socialboards',
            faqName: 'socialboards',
            isWidget: true,
            language: 'nb', // Language for call button of FAQ widget
            widgetUrl: environment.faqIframeUrl,
        };

        const widgetScript = document.createElement('script');
        widgetScript.type = 'text/javascript';
        widgetScript.async = true;
        widgetScript.src = environment.faqIframeUrl + 'app-widget/sb-widget.min.js';
        document.body.appendChild(widgetScript);

        const widgetLink = document.createElement('link');
        widgetLink.type = 'text/css';
        widgetLink.rel = 'stylesheet';
        widgetLink.href = environment.faqIframeUrl + 'app-widget/widget-client-side.min.css';
        document.head.appendChild(widgetLink);
    }

    private receiveMessage(event: MessageEvent) {
        if (event.data && event.data.isFaqAttachment) {
            this.bsModalService.show(DocumentViewerModalComponent, {
                initialState: event.data.message.initialState,
                class: 'modal-lg modal-document-viewer',
                id: DOCUMENT_VIEWER_MODAL_ID,
            });
        }
    }

    ngOnDestroy() {
        window.removeEventListener('message', this.receiveMessage);
    }
}
